export const GradeIconsData = {
  1: {
    color: "var(--white)",
    name: "tick-mark",
    bg: "var(--green-dark) !important",
    border: "solid var(--green-dark) !important",
  },
  0: {
    color: "var(--black)",
    name: "warning",
    bg: "var(--yellow-medium) !important",
    border: "solid var(--yellow-medium) !important",
  },
  "-1": {
    color: "var(--white)",
    name: "error",
    bg: "var(--red-medium) !important",
    border: "solid var(--red-medium) !important",
  },
};
